import React, { useEffect } from "react";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { Tooltip } from "antd";
import { ButtonProps } from "antd/lib/button/Button";
import {
  RecordingTableRow,
  useRecordingDelete,
} from "../../../../hooks/api/recordings";
import { listAction } from "../../../Common/Table";
import { useMessageError, useMessageSuccess } from "../../../../hooks/common";
import { useSimpleModal } from "../../../Common/Modal/Simple";

interface DeleteRecordingButtonProps {
  record: RecordingTableRow;
  setTableKey?: (newVal: number) => void;
  afterSuccess?: () => void;
  buttonProps?: ButtonProps;
}

export default function DeleteRecordingButton({
  record,
  setTableKey,
  afterSuccess,
  buttonProps,
}: DeleteRecordingButtonProps) {
  const recordingDelete = useRecordingDelete(record.id);
  const { open, contextHolder } = useSimpleModal();

  useMessageError([recordingDelete]);
  useMessageSuccess([recordingDelete], "Recording deleted");

  useEffect(() => {
    if (
      !recordingDelete.error &&
      !recordingDelete.loading &&
      recordingDelete.data
    ) {
      setTableKey?.(Date.now());
      afterSuccess?.();
    }
  }, [
    recordingDelete.error,
    recordingDelete.loading,
    recordingDelete.data,
    setTableKey,
    afterSuccess,
  ]);

  const ActionButton = listAction.delete;

  return (
    <>
      <Tooltip title="Delete recording" placement="topRight">
        <ActionButton
          loading={recordingDelete.loading}
          title="Delete recording?"
          onClick={(e: React.MouseEvent) => {
            e.preventDefault();
            e.stopPropagation();
            open({
              icon: <ExclamationCircleFilled />,
              title: "Delete recording?",
              content: (
                <span>
                  Are you sure you want to delete this recording from the
                  Content Library?
                </span>
              ),
              cancelText: "Cancel",
              okText: "Delete",
              okButtonProps: { danger: true },
              onOk: () =>
                recordingDelete.fetch().then(() => setTableKey?.(Date.now())),
            });
          }}
          {...buttonProps}
        />
      </Tooltip>
      {contextHolder}
    </>
  );
}
